<template>
  <modal
   :show.sync="isOpenLocal"
    scrollable
    header-classes="bg-primary p-2 flex items-center"
    size="lg"

  >
    <!-- <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
      Add News
    </h6> -->
    <h6 class="modal-title text-black font-semibold">Add Achievements</h6>
   
  </modal>
</template>

<script>
export default {
  data() {
    return {
      cname: "",
      author: "",
      cred: "",
      isOpenLocal:true,
      issued: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
      issend: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
      expend: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
      exp: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
    };
  },

  props: {
    isOpen: Boolean,
  },
  computed: {
   
  },
  methods: {
    
  },
};
</script>
